export interface User {
  id: string
  email: string
  firstName: string
  lastName: string
  fullName: string
  phone?: string
  // Valori reali osservati: Admin/Agent/Manager (Identity Role "di sistema", seed demo) più
  // AgencyOwner/BranchManager/BackOffice/LimitedUser (da EmployeeRole, assegnati dal modulo
  // Dipendenti) - vedi DbInitializer.cs e lib/employeeRoleLabels.ts. Union troppo stretta
  // rispetto ai valori reali, quindi string.
  role: string
  agencyId: string
  agencyName?: string
  branchId?: string
  employeeId?: string
  avatarUrl?: string
  twoFactorEnabled: boolean
  lastLogin?: string
  /** Operatore di piattaforma (multi-agenzia), distinto dal ruolo 'Admin' che è admin di UNA sola agenzia. */
  isSuperAdmin: boolean
}

export interface LoginRequest {
  email: string
  password: string
  rememberMe?: boolean
}

export interface LoginResponse {
  accessToken: string
  refreshToken: string
  expiresAt: string
  refreshTokenExpiresAt: string
  user: User
  permissions: string[]
}

/** Risposta di POST /auth/login quando l'utente ha il 2FA abilitato: il login non è ancora
 *  completo, va chiamato /auth/login/verify-2fa con mfaToken + il codice ricevuto via SMS. */
export interface LoginTwoFactorRequiredResponse {
  requiresTwoFactor: true
  mfaToken: string
  expiresInSeconds: number
}

export type LoginResult = LoginResponse | LoginTwoFactorRequiredResponse

export function isTwoFactorRequired(result: LoginResult): result is LoginTwoFactorRequiredResponse {
  return 'requiresTwoFactor' in result && result.requiresTwoFactor === true
}

export interface RefreshTokenRequest {
  refreshToken: string
}

export interface TokenPair {
  accessToken: string
  refreshToken: string
  expiresAt: string
}

export interface ChangePasswordRequest {
  currentPassword: string
  newPassword: string
}

export interface ForgotPasswordRequest {
  email: string
}

export interface ResetPasswordRequest {
  email: string
  token: string
  newPassword: string
}

export interface UpdateProfileRequest {
  firstName: string
  lastName: string
  phone?: string
}
